import { render, staticRenderFns } from "./_pendingTicketFcp.vue?vue&type=template&id=d522c844&lang=pug"
import script from "./_pendingTicketFcp.vue?vue&type=script&lang=js"
export * from "./_pendingTicketFcp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports